import React from 'react';
import * as Sentry from "@sentry/react";
import { hydrateRoot, createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { LanguageProvider } from './translations';
import { HelmetProvider } from 'react-helmet-async';

const helmetContext = {};

Sentry.init({
  dsn: "https://e9c60846519ada1af9ffabab23fe218e@o4509784981176320.ingest.de.sentry.io/4509785242992720",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

const AppWithProviders = () => (
  <HelmetProvider context={helmetContext}>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </HelmetProvider>
);

const rootElement = document.getElementById('root');

let hasFallenBackToClientRendering = false;

if (rootElement.hasChildNodes() && !hasFallenBackToClientRendering) {
  console.log('Hydrating existing server-rendered content...');
  try {
    hydrateRoot(rootElement, <AppWithProviders />);
    console.log('Hydration successful!');
  } catch (error) {
    console.warn('Hydration failed, falling back to client rendering:', error);
    hasFallenBackToClientRendering = true;
    while (rootElement.firstChild) {
      rootElement.removeChild(rootElement.firstChild);
    }
    createRoot(rootElement).render(<AppWithProviders />);
  }
} else {
  console.log('Rendering new content...');
  createRoot(rootElement).render(<AppWithProviders />);
}